// extracted by mini-css-extract-plugin
module.exports = {"CityAvatar":"CityAvatar_CityAvatar__sS2G4","CityAvatarImage":"CityAvatar_CityAvatarImage__P45v8"};